import loadable from '@loadable/component';

export const BlogMacroGalleryEdit = loadable(
  () => import(/* webpackChunkName: "redturtle__qubicaamf-theme" */ './Edit'),
);
